import React, { useEffect, useState } from 'react';
import { ThemedText, ThemedView } from '@app/theme';
import BottomSheetContainer from '@app/sharedComponents/Bottomsheet/Bottomsheet';
import gs from '../../../styles/globalStyles';
import Button from '@app/sharedComponents/Button/Button';
import RtaSelectionCard from './RtaSelectionCard';
import { DefaultRTA } from '@app/types';
import { trackEvent } from '@app/utils';

type EditRtaModalProps = {
    isVisible: boolean;
    onClose: () => void;
    defaultRTAData: DefaultRTA[] | null;
    defaultSelectedRTA: DefaultRTA | null;
    onConfirm: (rta: DefaultRTA[]) => void;
    routeName: string;
    title: string;
};

const EditRtaModal: React.FC<EditRtaModalProps> = ({
    isVisible,
    onClose,
    defaultRTAData,
    title,
    onConfirm,
    defaultSelectedRTA,
    routeName
}) => {
    const [_defaultRTAData, setDefaultRTAData] = useState<DefaultRTA[]>([]);
    const [hasInitialized, setHasInitialized] = useState(false);


    useEffect(() => {
        if (isVisible && !hasInitialized && defaultRTAData && defaultSelectedRTA) {
            setDefaultRTAData(defaultRTAData?.map((item: DefaultRTA) => ({
                ...item, 
                defaultRta: item.assetRepository === defaultSelectedRTA?.assetRepository
            })));
            setHasInitialized(true);
            trackEvent('EDIT_RTA_PAGE_VIEWED', {
                source: 'MF_FETCH_PORTFOLIO'
            })
        }
        
        if (!isVisible) {
            setHasInitialized(false);
        }
    }, [isVisible, defaultSelectedRTA, defaultRTAData, hasInitialized]);

    return (
        //@ts-expect-error
        <BottomSheetContainer
            isVisible={isVisible}
            close={() => {
                onClose();
            }}
            showCloseIcon={true}
            closeOnBackdropPress={false}
            borderTopRightRadius={10}
            borderTopLeftRadius={10}
            //@ts-expect-error
            containerStyle={gs.setBg('#fefefe')}
        >
            <ThemedView style={{ paddingTop: 24, paddingHorizontal: 16, paddingBottom: 16 }}>
                <ThemedText variant='h5s' fontWeight='600'>Select source for MF portfolio</ThemedText>
                <ThemedView style={{ height: 8 }} />
                <ThemedText variant='b3r' fontWeight='400' color='text-secondary'>{title}</ThemedText>
                <ThemedView style={{ height: 24 }} />
                <ThemedView>
                    {_defaultRTAData?.map((item, index) => (
                        <RtaSelectionCard 
                            key={`${item.repositoryName}-${index}`} 
                            rta={item} 
                            isSelected={_defaultRTAData?.find((rta: DefaultRTA) => rta.defaultRta === true)?.repositoryName === item.repositoryName} 
                            onSelect={setDefaultRTAData}
                            defaultRTAData={_defaultRTAData}
                            height={60}
                        />
                    ))}
                </ThemedView>
                <ThemedView style={{ height: 12 }} />
                <Button
                    eventName={'RTA_SELECTION_CONFIRM_BUTTON'}
                    additionalProperties={{
                        source: 'MF_FETCH_PORTFOLIO',
                        rtaName: _defaultRTAData?.find((rta: DefaultRTA) => rta.defaultRta === true)?.repositoryName,
                        rtaCount: _defaultRTAData?.length,
                    }}
                    label={'Confirm'}
                    handlePress={() => {
                        onConfirm(_defaultRTAData);
                    }}
                    type={'SOLID'}
                    size='MD'
                    bg='bg-primary'
                    textColor='text-primary'
                    disabled={false}
                    buttonLoader={false}
                />
            </ThemedView>
        </BottomSheetContainer>
    );
};

export default EditRtaModal; 